import { render, staticRenderFns } from "./QTDogRegistrationSignatures.vue?vue&type=template&id=210d4ea8"
import script from "./QTDogRegistrationSignatures.vue?vue&type=script&lang=ts"
export * from "./QTDogRegistrationSignatures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports